import { defineStore } from "pinia";
import { useStoreCompat } from "@/composables/useStoreCompat";

export const useValidationsStore = defineStore("validations", () => {
  const store = useStoreCompat();

  //Es importante no cambiar el orden de los elementos del siguiente array, ya que muchas acciones dependen de sus respectivos índices
  let categorizedErrors = [
    {
      type: "affecteds",
      textName: "Afectados",
      passed: false,
      validationFunction: function () {
        try {
          let passed = false;
          store.state.sumario.denunciante.list.length > 1 ? (passed = true) : (passed = false);
          this.passed = passed;
        } catch (e) {
          console.error("Error with 'affecteds':", e);
          this.passed = false;
        }
      },
    },
    {
      type: "deposition",
      textName: "Relato",
      passed: false,
      validationFunction: function () {
        try {
          let passed = true;
          let minLength = 600;
          if (store.state.sumario.actuationEditModeActive) {
            this.passed = true;
            return;
          }
          if (
            store.state.sumarioViews.actuacion === "contravencional-oficio" ||
            store.state.sumarioViews.actuacion === "contravencional-denuncia"
          )
            minLength = 400;
          if (store.state.sumario.deposition.length < minLength) passed = false;
          this.passed = passed;
        } catch (e) {
          console.error("Error with 'deposition':", e);
          this.passed = false;
        }
      },
    },
    //La sección de Personal interviniente no tiene "validationFunction()" porque se valida en el componente DenunciaForm.vue
    {
      type: "interveningPersonnel",
      textName: "Personal interviniente",
      passed: false,
    },
    {
      type: "datesAndLocations",
      textName: "Fecha, hora y ubicación",
      passed: false,
      validationFunction: function () {
        try {
          let passed = false;
          if (
            store.state.sumario.preUbicacion !== "string" &&
            Object.keys(store.state.sumario.preUbicacion).length > 0
          ) {
            passed = true;
          } else {
            passed = false;
          }
          this.passed = passed;
        } catch (e) {
          console.error("Error with 'datesAndLocations':", e);
          this.passed = false;
        }
      },
    },
    //La sección de Datos legales no tiene "validationFunction()" porque se valida en el componente ContravencionalFormDatos.vue
    {
      type: "legalData",
      textName: "Datos legales",
      passed: false,
      actuationShortcut: false,
      validatedFields: [],
    },
  ];

  const getValidationData = async () => {
    try {
      categorizedErrors.map((categorizedError) => {
        if (categorizedError.validationFunction !== undefined)
          categorizedError.validationFunction();
      });
      return categorizedErrors;
    } catch (e) {
      console.error("Error al obtener 'categorizedErrors':", e);
      return 0;
    }
  };

  const cleanCategorizedError = () => {
    categorizedErrors[4].validatedFields = [];
  };

  return {
    getValidationData,
    categorizedErrors,
    cleanCategorizedError,
  };
});
